import React from 'react';
import {
  Box,
  Typography,
  Container,
} from '@mui/material';

export default function HowItWorks() {
  const steps = [
    {
      num: '01',
      icon: '🎟️',
      title: 'Pick a coupon card',
      description: 'Choose Bronze, Silver or Gold based on how much assured cashback and how many premium brand deals you want unlocked.',
    },
    {
      num: '02',
      icon: '🔓',
      title: 'Activate any deal',
      description: 'Your card unlocks a running list of live deals across fashion, electronics, food and travel — each with a fixed, published payout.',
    },
    {
      num: '03',
      icon: '💸',
      title: 'Redeem & get paid',
      description: 'Shop with the brand using your code. Cashback or the branded reward lands in your iSoret wallet — same amount every time, no surprises.',
    },
  ];

  return (
    <Box
      component="section"
      id="how"
      sx={{
        padding: '80px 0',
        background: '#0F2E2B',
        position: 'relative',
      }}
    >
      <Container maxWidth="lg">
        {/* Section Header */}
        <Box
          sx={{
            textAlign: 'left',
            maxWidth: '640px',
            marginBottom: '56px',
          }}
        >
          <Typography
            sx={{
              fontFamily: '"JetBrains Mono", monospace',
              fontSize: '13px',
              color: '#E8C078',
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
            }}
          >
            The mechanics
          </Typography>
          <Typography
            variant="h2"
            sx={{
              fontFamily: '"Fraunces", serif',
              fontWeight: 700,
              fontSize: { xs: '32px', md: '40px' },
              color: '#F5F1E6',
              marginTop: '14px',
            }}
          >
            Three steps between you and a payout
          </Typography>
          <Typography
            sx={{
              color: 'rgba(245, 241, 230, 0.66)',
              fontSize: '16px',
              marginTop: '14px',
            }}
          >
            No wallets to top up blind, no odds to calculate. Pick a card, activate a deal, get paid when you redeem it.
          </Typography>
        </Box>

        {/* Steps Grid */}
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '28px',
            justifyContent: 'center',
            alignItems: 'stretch',
            width: '100%',
          }}
        >
          {steps.map((step, idx) => (
            <Box
              key={idx}
              sx={{
                background: '#153A35',
                border: '1px solid rgba(245, 241, 230, 0.14)',
                borderRadius: '18px',
                padding: '32px 26px',
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                flex: { xs: '1 1 100%', sm: '0 1 340px', md: '1 1 340px' },
                maxWidth: '360px',
                minWidth: '280px',
                transition: 'transform 0.3s ease, border-color 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-6px)',
                  borderColor: '#E8C078',
                },
              }}
            >
              {/* Step Number */}
              <Box
                sx={{
                  fontFamily: '"JetBrains Mono", monospace',
                  fontSize: '13px',
                  color: '#E8C078',
                  border: '1px solid rgba(245, 241, 230, 0.14)',
                  width: '36px',
                  height: '36px',
                  borderRadius: '50%',
                  display: 'grid',
                  placeItems: 'center',
                  marginBottom: '22px',
                }}
              >
                {step.num}
              </Box>

              {/* Icon */}
              <Typography
                component="span"
                sx={{
                  fontSize: '28px',
                  marginBottom: '14px',
                  display: 'block',
                }}
              >
                {step.icon}
              </Typography>

              {/* Title */}
              <Typography
                variant="h5"
                sx={{
                  fontFamily: '"Fraunces", serif',
                  fontSize: '20px',
                  color: '#F5F1E6',
                  fontWeight: 600,
                  marginBottom: '10px',
                }}
              >
                {step.title}
              </Typography>

              {/* Description */}
              <Typography
                sx={{
                  color: 'rgba(245, 241, 230, 0.66)',
                  fontSize: '14.5px',
                  lineHeight: 1.6,
                }}
              >
                {step.description}
              </Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
